import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { BaseSubsectionAdapter } from 'components/Assessments/adapters/BaseSubsectionAdapter'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { ServicePlanFormData } from 'components/Assessments/ServicePlanAssessment/types/ServicePlanFormData'
import { ServicePlanFormField } from 'components/Assessments/ServicePlanAssessment/types/ServicePlanFormField'
import { ServicePlanAssessmentQuestionnaireItem } from 'components/Assessments/ServicePlanAssessment/types/questionnaire'
import { getAppointmentTimeWithTimezone } from 'components/Assessments/helpers'
import { convertAppointmentTimeFormDataToFlatAnswers } from 'components/Assessments/helpers.uncontrolled'

/**
 * Assessment Overview subsection adapter for Service Plan Assessment
 * Handles appointment time extraction and transformation
 */
export class AssessmentOverviewAdapter extends BaseSubsectionAdapter<ServicePlanFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options?: AdapterOptions
  ): Partial<ServicePlanFormData> {
    const flatAnswersArray = Object.values(flatAnswers)
    const appointmentTime = getAppointmentTimeWithTimezone(
      flatAnswersArray,
      options?.caregiverTimezone
    )

    return {
      [ServicePlanFormField.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME]: appointmentTime
    }
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const hasAppointmentTime = this.formDataFieldExists(
      ServicePlanFormField.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME
    )
    const appointmentTimeField = hasAppointmentTime
      ? this.getFormDataField(ServicePlanFormField.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME)
      : undefined

    const { appointmentTimeValues } = convertAppointmentTimeFormDataToFlatAnswers(
      Array.isArray(appointmentTimeField) ? appointmentTimeField : [undefined, undefined]
    )

    return [
      {
        linkId: ServicePlanAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_START,
        value: appointmentTimeValues.at(0)
      },
      {
        linkId: ServicePlanAssessmentQuestionnaireItem.ASSESSMENT_OVERVIEW_APPOINTMENT_TIME_END,
        value: appointmentTimeValues.at(1)
      }
    ]
  }
}
